webpackJsonp([2],{

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_PostAPI__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Posts__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_PostSlider__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleFilter__ = __webpack_require__(275);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.state = {
      posts: [],
      isLoading: false,
      error: false,
      currentTerms: {
        product_model: '',
        product_style: ''
      }
    };

    _this.handleTermChoice = _this.handleTermChoice.bind(_this);
    return _this;
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      /**
       * Get product model from pageblock
       * and fetch all matching posts.
       */
      this.setState({
        currentTerms: {
          product_model: this.props.model,
          product_style: ''
        }
      }, this.fetchPosts);
    }
  }, {
    key: 'fetchPosts',
    value: function fetchPosts() {
      var _this2 = this;

      this.setState({ isLoading: true });

      __WEBPACK_IMPORTED_MODULE_1__api_PostAPI__["a" /* default */].all(this.state).then(function (response) {
        return response.json();
      }).then(function (data) {
        window.setTimeout(function () {
          _this2.setState({
            posts: [].concat(_toConsumableArray(_this2.state.posts), _toConsumableArray(data)),
            isLoading: false
          });
        }, 500);
      }).catch(function (error) {
        _this2.setState({
          error: true,
          isLoading: false
        });
      });
    }
  }, {
    key: 'handleTermChoice',
    value: function handleTermChoice(currentTerm, taxonomy) {
      var currentTerms = this.state.currentTerms;
      currentTerms[taxonomy] = currentTerm;

      this.setState(function () {
        return {
          currentTerms: currentTerms,
          posts: []
        };
      }, this.fetchPosts);
    }
  }, {
    key: 'render',
    value: function render() {
      var headerClass = this.props.sliderVisiblity !== 'hide' ? 'c-products-app__header' : 'c-products-app__header c-products-app__header--no-slider';
      var _props = this.props,
          title = _props.title,
          defaultOption = _props.defaultOption;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-products-app' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: headerClass },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { className: 'c-products-app__filters' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_4__StyleFilter__["a" /* default */], {
              currentTerm: this.state.currentTerms.product_style,
              onSelectTerm: this.handleTermChoice,
              model: this.props.model,
              postsLoading: this.state.isLoading,
              defaultOption: defaultOption,
              title: title
            })
          ),
          this.props.sliderVisiblity !== 'hide' && !this.state.isLoading ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__containers_PostSlider__["a" /* default */], { posts: this.state.posts, slidesCount: this.state.posts.length }) : null
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-products-app__body' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__components_Posts__["a" /* default */], {
            posts: this.state.posts,
            loading: this.state.isLoading,
            error: this.state.error,
            appointment: this.props.appointment,
            invoice: this.props.invoice
          })
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_scrollchor__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_scrollchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_scrollchor__);


// github.com/ltetzlaff/preact-scrollchor
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var PostSlide = function PostSlide(props) {

  var post = props.post;
  var title = post.title.rendered;
  var styles = post.product_style_names.join(', ');
  var image = post.product_image;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-product-slide c-product-slider__slide js-product-slide' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      __WEBPACK_IMPORTED_MODULE_1_preact_scrollchor___default.a,
      { to: '#' + post.slug },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', { className: 'c-product-slide__image', dangerouslySetInnerHTML: { __html: image } }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-product-slide__header' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('p', { className: 'c-product-slide__styles', dangerouslySetInnerHTML: { __html: styles } }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h3', { className: 'c-product-slide__title', dangerouslySetInnerHTML: { __html: title } })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PostSlide);

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorMessage__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Post__ = __webpack_require__(273);




// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Posts = function Posts(props) {
  if (props.error) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__ErrorMessage__["a" /* default */], { type: 'posts-error' });
  }

  if (!props.loading && props.posts.length === 0) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__ErrorMessage__["a" /* default */], { type: 'no-results' });
  }

  if (props.loading) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__Loader__["a" /* default */], null);
  }

  var container = document.getElementById('js-products-app');

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-products' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'p',
      { className: 'c-products__nr' },
      props.posts.length,
      ' ',
      container.dataset.producttext
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-products__row' },
      props.posts.map(function (post) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__containers_Post__["a" /* default */], { post: post, key: post.id, appointment: props.appointment, invoice: props.invoice });
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Posts);

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Post = function (_Component) {
  _inherits(Post, _Component);

  function Post(props) {
    _classCallCheck(this, Post);

    var _this = _possibleConstructorReturn(this, (Post.__proto__ || Object.getPrototypeOf(Post)).call(this, props));

    var container = document.getElementById('js-products-app');
    _this.state = {
      active: false,
      activeClass: '',
      triggerText: container.dataset.readmore
    };

    _this.handleToggle = _this.handleToggle.bind(_this);
    return _this;
  }

  _createClass(Post, [{
    key: 'handleToggle',
    value: function handleToggle() {
      var container = document.getElementById('js-products-app');
      if (this.state.active) {
        this.setState({
          active: !this.state.active,
          activeClass: '',
          triggerText: container.dataset.readmore
        });
      } else {
        this.setState({
          active: !this.state.active,
          activeClass: 'active',
          triggerText: container.dataset.readless
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          post = _props.post,
          invoice = _props.invoice,
          appointment = _props.appointment;


      var styles = post.product_style_names.join(', ');
      var invoice_url = invoice + '/?product=' + post.slug + '&product_id=' + post.id;
      var appointment_url = appointment + '/?product=' + post.slug;

      var container = document.getElementById('js-products-app');

      var _container$dataset = container.dataset,
          priceindication = _container$dataset.priceindication,
          size = _container$dataset.size,
          metric = _container$dataset.metric,
          invoicetext = _container$dataset.invoicetext,
          appointmenttext = _container$dataset.appointmenttext;


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-product c-products__col', id: post.slug },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', { className: 'c-product__image', dangerouslySetInnerHTML: { __html: post.feat_image } }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-product__body' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('p', { className: 'c-product__styles', dangerouslySetInnerHTML: { __html: styles } }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h3', { className: 'c-product__title', dangerouslySetInnerHTML: { __html: post.title.rendered } }),
          post.product_price && post.product_length && post.product_width ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'p',
            { className: 'c-product__meta' },
            priceindication,
            ' \u20AC ',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', { dangerouslySetInnerHTML: { __html: post.product_price } }),
            ' ',
            size,
            ' ',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', { dangerouslySetInnerHTML: { __html: post.product_length } }),
            ' x',
            ' ',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', { dangerouslySetInnerHTML: { __html: post.product_width } }),
            ' ',
            metric
          ) : null,
          post.content.rendered ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { className: 'c-product-toggle ' + this.state.activeClass, onClick: this.handleToggle },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'div',
              { className: 'c-product-toggle__trigger' },
              this.state.triggerText,
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
                'div',
                { 'class': 'c-product-toggle__expand' },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', null),
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', null)
              )
            ),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', { className: 'c-product-toggle__panel', dangerouslySetInnerHTML: { __html: post.content.rendered } })
          ) : null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { className: 'c-product__buttons' },
            invoicetext ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'a',
              { href: invoice_url, className: 'c-product__button c-product__button--black' },
              invoicetext,
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
                'svg',
                { 'class': 'c-icon c-product__icon' },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('use', { href: '#slider-chevron-right', xlinkHref: '#slider-chevron-right' })
              )
            ) : null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'a',
              { href: appointment_url, className: 'c-product__button c-product__button--border' },
              appointmenttext,
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
                'svg',
                { 'class': 'c-icon c-product__icon' },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('use', { href: '#slider-chevron-right', xlinkHref: '#slider-chevron-right' })
              )
            )
          )
        )
      );
    }
  }]);

  return Post;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (Post);

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PostSlide__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ErrorMessage__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loader__ = __webpack_require__(34);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var PostSlider = function (_Component) {
  _inherits(PostSlider, _Component);

  function PostSlider(props) {
    _classCallCheck(this, PostSlider);

    var _this = _possibleConstructorReturn(this, (PostSlider.__proto__ || Object.getPrototypeOf(PostSlider)).call(this, props));

    _this.state = {
      pos: 0,
      shown: 0,
      slideWidth: 0,
      sliderWidth: 0,
      sliderScrollWidth: 0,
      nextActivity: 'inactive',
      prevActivity: 'inactive',
      sliderStyle: ''
    };

    _this.setValues = _this.setValues.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.setTransform = _this.setTransform.bind(_this);
    _this.goPrev = _this.goPrev.bind(_this);
    _this.goNext = _this.goNext.bind(_this);
    _this.navActivity = _this.navActivity.bind(_this);
    return _this;
  }

  _createClass(PostSlider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.setValues();
      document.addEventListener('keydown', function (e) {
        return _this2.handleKeydown(e);
      }, false);
      window.addEventListener('resize', this.setValues);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      document.removeEventListener('keydown', function (e) {
        return _this3.handleKeydown(e);
      }, false);
      window.removeEventListener('resize', this.setValues);
    }
  }, {
    key: 'setValues',
    value: function setValues() {
      var slider = document.querySelector('.js-product-slider');
      var firstSlide = document.querySelector('.js-product-slide');

      if (slider && firstSlide) {
        this.setState(function () {
          return {
            pos: 0,
            shown: slider.offsetWidth,
            slideWidth: firstSlide.offsetWidth,
            sliderWidth: slider.offsetWidth,
            sliderScrollWidth: slider.scrollWidth
          };
        }, this.setTransform);
      }
    }
  }, {
    key: 'handlePrev',
    value: function handlePrev() {
      this.goPrev();
    }
  }, {
    key: 'handleNext',
    value: function handleNext() {
      this.goNext();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === 39) {
        this.goNext();
      }
      if (e.keyCode === 37) {
        this.goPrev();
      }
    }
  }, {
    key: 'setTransform',
    value: function setTransform() {
      var nr = this.state.pos * this.state.slideWidth;

      this.setState(function () {
        return {
          sliderStyle: 'transform: translate3d(-' + nr + 'px,0,0)'
        };
      }, this.navActivity);
    }
  }, {
    key: 'goPrev',
    value: function goPrev() {
      var _this4 = this;

      if (this.state.pos > 0) {
        this.setState(function () {
          return {
            pos: Math.max(_this4.state.pos - 1, 0),
            shown: _this4.state.shown - _this4.state.slideWidth
          };
        }, this.setTransform);
      }
    }
  }, {
    key: 'goNext',
    value: function goNext() {
      var _this5 = this;

      if (this.state.shown < this.state.sliderScrollWidth) {
        this.setState(function () {
          return {
            pos: Math.min(_this5.state.pos + 1, _this5.props.slidesCount - 1),
            shown: _this5.state.shown + _this5.state.slideWidth
          };
        }, this.setTransform);
      }
    }
  }, {
    key: 'navActivity',
    value: function navActivity() {
      // Can we still go previous?
      if (this.state.pos > 0) {
        this.setState({ prevActivity: 'active' });
      } else {
        this.setState({ prevActivity: 'inactive' });
      }
      // Can we still go next?
      if (this.state.shown < this.state.sliderScrollWidth) {
        this.setState({ nextActivity: 'active' });
      } else {
        this.setState({ nextActivity: 'inactive' });
      }
    }
  }, {
    key: 'render',
    value: function render() {

      if (this.props.error) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__components_ErrorMessage__["a" /* default */], { type: 'filter-error' });
      }

      if (this.props.isLoading) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__components_Loader__["a" /* default */], null);
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-product-slider-parent' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-product-slider js-product-slider', style: this.state.sliderStyle },
          this.props.posts.map(function (post) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__components_PostSlide__["a" /* default */], { post: post, key: post.id });
          }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', { className: 'c-product-slider__filler' })
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { onClick: this.handlePrev, className: 'c-product-slider-nav c-product-slider-nav--prev ' + this.state.prevActivity },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'svg',
            { 'class': 'c-icon c-product-slider-nav__icon' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('use', { href: '#slider-chevron-left', xlinkHref: '#slider-chevron-left' })
          )
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { onClick: this.handleNext, className: 'c-product-slider-nav c-product-slider-nav--next ' + this.state.nextActivity },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'svg',
            { 'class': 'c-icon c-product-slider-nav__icon' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('use', { href: '#slider-chevron-right', xlinkHref: '#slider-chevron-right' })
          )
        )
      );
    }
  }]);

  return PostSlider;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (PostSlider);

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_PostAPI__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ErrorMessage__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loader__ = __webpack_require__(34);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var StyleFilter = function (_Component) {
  _inherits(StyleFilter, _Component);

  function StyleFilter(props) {
    _classCallCheck(this, StyleFilter);

    var _this = _possibleConstructorReturn(this, (StyleFilter.__proto__ || Object.getPrototypeOf(StyleFilter)).call(this, props));

    _this.state = {
      posts: [],
      currentTerms: {
        product_model: _this.props.model,
        product_style: ''
      },
      terms: [],
      error: false,
      isLoading: false
    };

    _this.handleTerm = _this.handleTerm.bind(_this);
    _this.fillTerms = _this.fillTerms.bind(_this);
    return _this;
  }

  _createClass(StyleFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchPosts();
    }
  }, {
    key: 'fetchPosts',
    value: function fetchPosts() {
      var _this2 = this;

      this.setState({ isLoading: true });

      __WEBPACK_IMPORTED_MODULE_1__api_PostAPI__["a" /* default */].all(this.state).then(function (response) {
        return response.json();
      }).then(function (data) {

        _this2.setState(function () {
          return {
            posts: [].concat(_toConsumableArray(_this2.state.posts), _toConsumableArray(data)),
            isLoading: false
          };
        }, _this2.fillTerms);
      }).catch(function (error) {
        _this2.setState({
          error: true,
          isLoading: false
        });
      });
    }
  }, {
    key: 'fillTerms',
    value: function fillTerms() {
      var allTerms = [];

      // Get all terms in all posts (= with duplicates) as flat array
      this.state.posts.map(function (post) {
        var termsArray = post.product_style_objects;[].concat(_toConsumableArray(termsArray)).forEach(function (term) {
          allTerms.push(term);
        });
      });

      // Filter out duplicates
      var uniqueTerms = allTerms.filter(function (obj, pos, arr) {
        return arr.map(function (mapObj) {
          return mapObj['term_id'];
        }).indexOf(obj['term_id']) === pos;
      });

      this.setState({
        terms: uniqueTerms
      });
    }
  }, {
    key: 'handleTerm',
    value: function handleTerm(e) {
      this.props.onSelectTerm(e.target.value, 'product_style');
    }
  }, {
    key: 'generateButtons',
    value: function generateButtons() {
      var _this3 = this;

      var buttons = [];

      // Default button
      buttons.push(this.generateDefaultButton());

      // Make a button for each term
      this.state.terms.map(function (term) {

        // Skip term if it has no posts
        if (term.count === 0) return false;

        // Set current class
        var buttonClass = 'c-product-filter__button';
        if (_this3.props.currentTerm == term.term_id) {
          buttonClass = 'c-product-filter__button active';
        }

        // Push to array
        return buttons.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('button', {
          className: buttonClass,
          value: term.term_id,
          key: term.term_id,
          onClick: _this3.handleTerm,
          dangerouslySetInnerHTML: { __html: term.name },
          disabled: _this3.props.postsLoading
        }));
      });

      return buttons;
    }
  }, {
    key: 'generateDefaultButton',
    value: function generateDefaultButton() {
      // Set current class
      var defaultClass = 'c-product-filter__button';
      if (this.props.currentTerm == '') {
        defaultClass = 'c-product-filter__button active';
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('button', {
        className: defaultClass,
        value: '',
        onClick: this.handleTerm,
        dangerouslySetInnerHTML: { __html: this.props.defaultOption },
        disabled: this.props.postsLoading
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          error = _state.error,
          isLoading = _state.isLoading;


      if (error) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__components_ErrorMessage__["a" /* default */], { type: 'filter-error' });
      }

      if (isLoading) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__components_Loader__["a" /* default */], null);
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-product-filter' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h6', {
          dangerouslySetInnerHTML: { __html: this.props.title },
          className: 'c-product-filter__title'
        }),
        this.generateButtons()
      );
    }
  }]);

  return StyleFilter;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (StyleFilter);

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_App__ = __webpack_require__(225);




// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var container = document.getElementById('js-products-app');

if (container) {
  var model = container.dataset.model;
  var appointment = container.dataset.appointment;
  var invoice = container.dataset.invoice;
  var slider = container.dataset.slider;
  var filterTitle = container.dataset.filtertitle;
  var defaultOption = container.dataset.defaultoption;

  if (model === undefined) {
    throw Error('Products app: dataset-model is undefined.');
  }
  if (appointment === undefined) {
    throw Error('Products app: dataset-appointment is undefined.');
  }
  if (invoice === undefined) {
    throw Error('Products app: dataset-invoice is undefined.');
  }
  if (slider === undefined) {
    throw Error('Products app: dataset-slider is undefined.');
  }

  if (filterTitle === undefined) {
    throw Error('Products app: dataset-filtertitle is undefined.');
  }

  if (defaultOption === undefined) {
    throw Error('Products app: dataset-defaultoption is undefined.');
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* render */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__containers_App__["a" /* default */], {
    title: filterTitle,
    model: model,
    appointment: appointment,
    invoice: invoice,
    sliderVisiblity: slider,
    defaultOption: defaultOption
  }), container);
}

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
function animationFrame() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return window.requestAnimationFrame(resolve); })];
        });
    });
}
exports.animationFrame = animationFrame;
//# sourceMappingURL=animation-frame.js.map

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = __webpack_require__(292);
var utils_1 = __webpack_require__(291);
var Scrollchor = /** @class */ (function (_super) {
    __extends(Scrollchor, _super);
    function Scrollchor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Scrollchor.prototype.simulateClick = function () {
        this.handleClick();
    };
    Scrollchor.prototype.handleClick = function (event) {
        var _a = this.props, beforeAnimate = _a.beforeAnimate, to = _a.to, animate = _a.animate, afterAnimate = _a.afterAnimate, disableHistory = _a.disableHistory;
        if (beforeAnimate)
            beforeAnimate(event);
        if (event)
            event.preventDefault();
        var toNoHash = to.replace(/^#/, "");
        var id = utils_1.animateScroll(toNoHash, animate);
        if (id) {
            if (disableHistory) {
                utils_1.updateHistory();
            }
            else {
                utils_1.updateHistory(id);
            }
            if (afterAnimate)
                afterAnimate(event);
        }
    };
    Scrollchor.prototype.render = function (_a) {
        var _this = this;
        var to = _a.to, children = _a.children;
        return children ? (preact_1.h("a", { href: to, onClick: function (e) { return _this.handleClick(e); } }, children)) : null;
    };
    return Scrollchor;
}(preact_1.Component));
exports.default = Scrollchor;
//# sourceMappingURL=scrollchor.js.map

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var animation_frame_1 = __webpack_require__(289);
// Default easing function
// jQuery easing 'swing'
// tslint:disable-next-line:no-magic-numbers
var easeOutQuad = function (_, t, b, c, d) { return -c * (t /= d) * (t - 2) + b; };
function removeHash() {
    var url = window.location.toString().split("#")[0];
    window.history.replaceState({}, document.title, url);
}
function updateHistory(id) {
    if (id) {
        window.location.hash = id;
    }
    else {
        removeHash();
    }
}
exports.updateHistory = updateHistory;
function getScroll() {
    // like jQuery -> $('html, body').scrollTop
    return document.documentElement.scrollTop || document.body.scrollTop;
}
function scroll(position) {
    document.documentElement.scrollTop = document.body.scrollTop = position;
}
function getOffsetTop(element) {
    return element.getBoundingClientRect().top;
}
var scrollToken = -1;
function animateScroll(id, animate) {
    var _this = this;
    var element = id ? document.getElementById(id) : document.body;
    if (!element) {
        console.warn("Cannot find element: #" + id);
        return undefined;
    }
    var _a = animate || {}, 
    // default animate object
    _b = _a.offset, 
    // default animate object
    offset = _b === void 0 ? 0 : _b, 
    // tslint:disable-next-line:no-magic-numbers
    _c = _a.duration, 
    // tslint:disable-next-line:no-magic-numbers
    duration = _c === void 0 ? 400 : _c, _d = _a.easing, easing = _d === void 0 ? easeOutQuad : _d;
    var startTime = Date.now();
    scrollToken = startTime;
    var s0 = getScroll();
    var change = getOffsetTop(element) + offset;
    var animateFn = function () { return __awaiter(_this, void 0, void 0, function () {
        var dt, position;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dt = Date.now() - startTime;
                    position = easing(undefined, dt, s0, change, duration);
                    scroll(position);
                    if (!(dt < duration)) return [3 /*break*/, 2];
                    return [4 /*yield*/, animation_frame_1.animationFrame()];
                case 1:
                    _a.sent();
                    if (scrollToken !== startTime)
                        return [2 /*return*/];
                    animateFn();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    animateFn();
    return id;
}
exports.animateScroll = animateScroll;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRef", function() { return createRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rerender", function() { return rerender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

function applyRef(ref, value) {
  if (ref != null) {
    if (typeof ref == 'function') ref(value);else ref.current = value;
  }
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p;
	while (p = items.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		applyRef(old, null);
		applyRef(value, node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.shift()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	applyRef(component.__ref, component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.push(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	applyRef(component.__ref, null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

function createRef() {
	return {};
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	createRef: createRef,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* harmony default export */ __webpack_exports__["default"] = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return h; });
/* unused harmony export createElement */
/* unused harmony export cloneElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* unused harmony export rerender */
/* unused harmony export options */
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* unused harmony default export */ var _unused_webpack_default_export = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(3);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var ErrorMessage = function ErrorMessage(props) {

  var message = 'Something went wrong.';

  if (props.type === 'no-results') {
    message = 'Geen resultaten gevonden.';
  } else if (props.type === 'filter-error') {
    message = 'De filter kon niet geladen worden.';
  } else if (props.type === 'posts-error') {
    message = 'De producten konden niet geladen worden. Ververs a.u.b. de pagina.';
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-products-app__error' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-products-app__error-message' },
      message
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorMessage);

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(3);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Loader = function Loader() {

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    "div",
    { className: "c-products-loader" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect1" }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect2" }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect3" }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect4" }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect5" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PostAPI = function () {
  function PostAPI() {
    _classCallCheck(this, PostAPI);
  }

  _createClass(PostAPI, null, [{
    key: 'all',
    value: function all(state) {
      var url = this.postsUrl(state);

      return fetch(url, {
        credentials: 'same-origin'
      }).then(this.handleStatus);
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(response) {
      if (!response.ok) {
        // Fetch doesn't reject on HTTP error status
        throw Error('Products PostAPI: Request rejected with status ' + response.status);
      }
      return response;
    }
  }, {
    key: 'postsUrl',
    value: function postsUrl(params) {
      var currentTerms = params.currentTerms;


      var orderby = this.orderQuery();

      // Get term queries
      var currentModel = currentTerms.product_model;
      var model = currentModel ? '&product_model=' + currentModel : '';

      var currentStyle = currentTerms.product_style;
      var style = currentStyle ? '&product_style=' + currentStyle : '';

      // Combine query
      var query = model + style;

      return '/wp-json/wp/v2/product?per_page=99&' + orderby + query;
    }
  }, {
    key: 'orderQuery',
    value: function orderQuery() {
      return 'orderby=menu_order';
    }
  }]);

  return PostAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (PostAPI);

/***/ })

},[276]);


// WEBPACK FOOTER //
// products.6cee4b38e25424dc7603.js